module.exports = __webpack_public_path__ + "static/media/MCT-Web-Slider_4_1020px.8f739a6b.jpg";